module.exports = __webpack_public_path__ + "static/img/4008.e57ad3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4008.png
// module id = 715
// module chunks = 0 1 12